import { matchStudioRoute, StudioPageRoutes } from './studioRoutes.js';

export const MARKETPLACE_TARGET_ID = 'marketplace';
export const MARKETPLACE_SITE_TARGET_ID = 'marketplace-site';
export const WAREHOUSE_TARGET_ID = 'warehouse';

const SCRATCH_APP_TARGET_ID_PREFIX = 'scratch-app:';

export function hostPreviewPathForTargetId(targetId: string): string {
  if (targetId === MARKETPLACE_TARGET_ID) {
    return `/${MARKETPLACE_TARGET_ID}`;
  }
  if (targetId === MARKETPLACE_SITE_TARGET_ID) {
    return `/${MARKETPLACE_SITE_TARGET_ID}`;
  }
  if (targetId === WAREHOUSE_TARGET_ID) {
    return `/${WAREHOUSE_TARGET_ID}`;
  }
  if (targetId.startsWith(SCRATCH_APP_TARGET_ID_PREFIX)) {
    const slug = targetId.slice(SCRATCH_APP_TARGET_ID_PREFIX.length);
    if (slug !== '') {
      return `/app/${encodeURIComponent(slug)}`;
    }
  }
  return `/target/${encodeURIComponent(targetId)}`;
}

export function targetIdFromHostPreviewPath(pathname: string): string | undefined {
  if (pathname === `/${MARKETPLACE_TARGET_ID}`) {
    return MARKETPLACE_TARGET_ID;
  }
  if (pathname === `/${MARKETPLACE_SITE_TARGET_ID}`) {
    return MARKETPLACE_SITE_TARGET_ID;
  }
  if (pathname === `/${WAREHOUSE_TARGET_ID}`) {
    return WAREHOUSE_TARGET_ID;
  }
  const scratch = matchStudioRoute(pathname, '/app/:slug');
  const scratchSlug = scratch?.params[0];
  if (scratchSlug !== undefined && scratchSlug !== '') {
    return `${SCRATCH_APP_TARGET_ID_PREFIX}${decodeURIComponent(scratchSlug)}`;
  }
  const generic = matchStudioRoute(pathname, '/target/:targetId');
  const encodedId = generic?.params[0];
  if (encodedId !== undefined && encodedId !== '') {
    return decodeURIComponent(encodedId);
  }
  return undefined;
}

export function isLegacyHomePath(pathname: string): boolean {
  return pathname === StudioPageRoutes.HOME;
}

export function isHostPreviewPath(pathname: string): boolean {
  return isLegacyHomePath(pathname) || targetIdFromHostPreviewPath(pathname) !== undefined;
}

export function isKnownStudioPagePath(pathname: string): boolean {
  if (pathname === StudioPageRoutes.ROOT || pathname === '') {
    return true;
  }
  if (
    pathname === StudioPageRoutes.APPS ||
    pathname === StudioPageRoutes.AUTOMATIONS ||
    pathname === StudioPageRoutes.HOME
  ) {
    return true;
  }
  if (matchStudioRoute(pathname, StudioPageRoutes.SESSION(':sessionId')) !== undefined) {
    return true;
  }
  return targetIdFromHostPreviewPath(pathname) !== undefined;
}

export function hostPreviewPathOrApps(targetId: string | undefined): string {
  if (targetId === undefined || targetId === '') {
    return StudioPageRoutes.APPS;
  }
  return hostPreviewPathForTargetId(targetId);
}
